/**
 * PDP rating-row avatars from Judge.me review photos.
 *
 * Mikkel (Round 2 #27): grab images from reviews; show the overlapping
 * circles next to the rating count only when there are at least 3 photos,
 * otherwise leave that slot empty.
 *
 * Sources (in order):
 * 1. Legacy `.jdgm-gallery-data[data-json]` (pre-revamp Judge.me widget)
 * 2. Revamp: `jdgm.data.reviewWidget[productId].photo_gallery`
 */
(function () {
  var MIN_IMAGES = 3;
  var MAX_AVATARS = 4;
  var POLL_MS = 400;
  var POLL_MAX_MS = 12000;

  function pushUrl(urls, seen, raw) {
    var url = String(raw || '').trim();
    if (!url || seen[url]) return;
    seen[url] = true;
    urls.push(url);
  }

  function urlsFromItems(data) {
    if (!Array.isArray(data)) return [];

    var urls = [];
    var seen = Object.create(null);

    data.forEach(function (item) {
      if (!item) return;

      if (typeof item === 'string') {
        pushUrl(urls, seen, item);
        return;
      }

      var pics = item.pictures_urls || item.pictures || item.photos || item.images;
      if (Array.isArray(pics)) {
        pics.forEach(function (pic) {
          if (!pic) return;
          if (typeof pic === 'string') {
            pushUrl(urls, seen, pic);
            return;
          }
          pushUrl(
            urls,
            seen,
            pic.compact || pic.small || pic.huge || pic.original || pic.url || pic.src
          );
        });
        return;
      }

      pushUrl(
        urls,
        seen,
        item.url || item.src || item.thumb_url || item.thumbnail || item.image
      );
    });

    return urls;
  }

  function parseLegacyGalleryUrls() {
    var el = document.querySelector('.jdgm-gallery-data[data-json]');
    if (!el) return [];

    var raw = el.getAttribute('data-json');
    if (!raw) return [];

    try {
      return urlsFromItems(JSON.parse(raw));
    } catch (err) {
      return [];
    }
  }

  function resolveProductId() {
    if (window.meta && meta.product && meta.product.id) return String(meta.product.id);

    var host = document.querySelector('[data-bjaf-review-avatars]');
    var fromHost = host && host.closest('[data-product-id]');
    if (fromHost) return String(fromHost.getAttribute('data-product-id'));

    var formId = document.querySelector('form[action*="/cart/add"] [name="product-id"]');
    if (formId && formId.value) return String(formId.value);

    var widget = document.querySelector('#judgeme_product_reviews[data-id], .jdgm-review-widget[data-id]');
    if (widget && widget.getAttribute('data-id')) return String(widget.getAttribute('data-id'));

    if (window.jdgm && jdgm.data && jdgm.data.reviewWidget) {
      var keys = Object.keys(jdgm.data.reviewWidget);
      if (keys.length === 1) return keys[0];
    }

    return null;
  }

  function parseRevampGalleryUrls() {
    if (!window.jdgm || !jdgm.data || !jdgm.data.reviewWidget) return [];

    var productId = resolveProductId();
    var widget = productId ? jdgm.data.reviewWidget[productId] : null;
    if (!widget) {
      var keys = Object.keys(jdgm.data.reviewWidget);
      if (keys.length === 1) widget = jdgm.data.reviewWidget[keys[0]];
    }
    if (!widget) return [];

    var gallery =
      widget.photo_gallery ||
      widget.picture_urls ||
      widget.pictures ||
      widget.review_photos ||
      [];
    return urlsFromItems(gallery);
  }

  function parseGalleryUrls() {
    var legacy = parseLegacyGalleryUrls();
    if (legacy.length) return legacy;
    return parseRevampGalleryUrls();
  }

  function render(urls) {
    var host = document.querySelector('[data-bjaf-review-avatars]');
    if (!host) return false;

    if (urls.length < MIN_IMAGES) {
      host.hidden = true;
      host.innerHTML = '';
      return false;
    }

    host.innerHTML = '';
    urls.slice(0, MAX_AVATARS).forEach(function (url) {
      var span = document.createElement('span');
      span.className = 'bjaf-pdp-rating__avatar';
      var img = document.createElement('img');
      img.src = url;
      img.alt = '';
      img.loading = 'lazy';
      img.decoding = 'async';
      img.width = 24;
      img.height = 24;
      span.appendChild(img);
      host.appendChild(span);
    });
    host.hidden = false;
    return true;
  }

  function tryFill() {
    return render(parseGalleryUrls());
  }

  if (tryFill()) return;

  var done = false;
  function succeed() {
    if (done) return true;
    if (!tryFill()) return false;
    done = true;
    observer.disconnect();
    clearInterval(pollId);
    clearTimeout(stopId);
    return true;
  }

  var observer = new MutationObserver(function () {
    succeed();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  // Judge.me often fills jdgm.data without a DOM mutation we can see.
  var pollId = setInterval(function () {
    succeed();
  }, POLL_MS);

  var stopId = setTimeout(function () {
    observer.disconnect();
    clearInterval(pollId);
    tryFill();
  }, POLL_MAX_MS);
})();
